import { Virtualizer } from '@tanstack/react-virtual';
import { VirtualMessageThreadContainerContext } from '../context';
import { VirtualMessagingThreadItem } from '../util';
import clsx from 'clsx';

interface VirtualMessageThreadContainerProps {
  className?: string;
  children: React.ReactNode;
  virtualizerItems: VirtualMessagingThreadItem[];
  virtualizer: Virtualizer<HTMLDivElement, Element>;
}

export function VirtualMessageThreadContainer({
  children,
  className,
  virtualizer,
  virtualizerItems,
}: VirtualMessageThreadContainerProps) {
  return (
    <div className={clsx(className, 'w-full relative')} style={{ height: virtualizer.getTotalSize() }}>
      <div
        className="absolute top-0 left-0 w-full grid"
        style={{
          transform: `translateY(${virtualizer.getVirtualItems()[0]?.start ?? 0}px)`,
          gap: `${virtualizer.options.gap ?? 0}px`,
        }}
      >
        {virtualizer.getVirtualItems().map((virtualItem) => (
          <VirtualMessageThreadContainerContext.Provider
            key={virtualItem.key.toString()}
            value={{ virtualItem, virtualizerItems }}
          >
            {children}
          </VirtualMessageThreadContainerContext.Provider>
        ))}
      </div>
    </div>
  );
}
